import React from 'react';
import { getMedia, mediaUrl } from '../../../content/productMedia';
import ProductMediaElement from './ProductMediaElement';

/**
 * Renders product screenshots and looping clips at full intrinsic dimensions, no cropping.
 * Portrait CoWork captures are centered with a max width so they stay readable.
 */
export default function ProductMediaFigure({
  id,
  aspect = 'natural',
  showCaption = true,
  className = '',
  rounded = 'rounded-2xl',
}) {
  const asset = getMedia(id);
  if (!asset) return null;

  const src = mediaUrl(asset);
  const isPortrait = asset.orientation === 'portrait';

  const frameClass = isPortrait
    ? 'flex justify-center bg-surface-subtle/50 leading-none px-2 py-2'
    : 'bg-surface-subtle/30 leading-none';

  const imgClass = isPortrait
    ? 'block h-auto max-h-[min(80vh,900px)] w-auto max-w-full'
    : asset.type === 'mp4'
      ? 'block h-auto w-full max-w-full mx-auto'
      : 'block h-auto w-full max-w-full';

  return (
    <figure className={`overflow-hidden border border-ink-200 bg-white shadow-sm ${rounded} ${className}`}>
      <div className={frameClass}>
        <ProductMediaElement asset={asset} src={src} className={imgClass} />
      </div>
      {showCaption && asset.caption && (
        <figcaption className="px-4 py-3 text-xs text-ink-500 border-t border-ink-100 bg-surface-subtle/60 leading-relaxed">
          <span className="inline-flex items-center gap-1.5 mr-2" aria-hidden="true">
            <span
              className={`text-[10px] font-semibold uppercase tracking-wide px-1.5 py-0.5 rounded ${
                asset.surface === 'cowork' ? 'bg-accent-50 text-accent-700' : 'bg-brand-50 text-brand-700'
              }`}
            >
              {asset.surface === 'cowork' ? 'CoWork' : 'Semantic HR'}
            </span>
            {asset.type === 'mp4' && (
              <span className="text-[10px] font-medium text-ink-400 uppercase tracking-wide">Clip</span>
            )}
            {asset.type === 'gif' && (
              <span className="text-[10px] font-medium text-ink-400 uppercase tracking-wide">GIF</span>
            )}
          </span>
          {asset.caption}
        </figcaption>
      )}
    </figure>
  );
}
